module.exports = __webpack_public_path__ + "static/media/appleMusic.79638f10.png";